$(document).ready(function() {

    var hoverDelay;

    $(".header__inline-menu_hover").hover(
        function() {
            clearTimeout(hoverDelay);
            hoverDelay = setTimeout(function() {
                $(".header__inline-menu_hover").removeClass("hover-active");
                $("body").stop().addClass("header-open", "slow");
                $(this).addClass("hover-active");
            }.bind(this), 150);
        },
        function() {
            clearTimeout(hoverDelay);
            hoverDelay = setTimeout(function() {
                $("body").stop().removeClass("header-open", "slow");
                $(".header__inline-menu_hover").removeClass("hover-active");
            }.bind(this), 150);
        }
    );

    $('.block_section-header--cate-block').each(function () {
    var $block = $(this);
    var $listItems = $block.find('.block_section-header--inner-link li');
    var$listItems = $block.find('.block_section-header--inner-link li a');
  
   $listItems.on('mouseenter', function () {
      var data_link_menu = $(this).find('.block_section-header--child').attr('data-menu-product-title');
      var data_link_menu_image = $(this).find('.block_section-header--image').attr('data-menu-product-image');
      if (data_link_menu === data_link_menu_image) {
        $listItems.removeClass('block-header-inner-active');
        $(this).addClass('block-header-inner-active');
      }
    }).on('mouseleave', function () {
      // Handle mouse leave (if needed)
    });
  
    $listItems.first().addClass('block-header-inner-active');
  });
  

  $('.header__inline-menu_hover').each(function (index) {
    var $menu = $(this);
    if (index >= 2) {
      $menu.find('.plus').remove();
    }
  });

  $('.header__inline-menu_hover:lt(2)').each(function () {
    var $menu = $(this);
    $menu.find('.otherlink .block_section-header--inner-link').hide();
    $menu.find('.otherlink .block_section-header--link-href:first').addClass('active').find('.block_section-header--inner-link').show();
    $menu.find('.plus').on('click', function () {
      var accordion = $(this).closest('.block_section-header--link-href');
      $menu.find('.otherlink .block_section-header--link-href').not(accordion).removeClass('active').find('.block_section-header--inner-link').slideUp();
      accordion.toggleClass('active');
      accordion.find('.block_section-header--inner-link').slideToggle();
    });
  });


    /* ===============================
       SHIPPING COUNTDOWN 
    =============================== */


    /* ===============================
    PRODUCT PAGE COUNTDOWN PRIORITY
    =============================== */

    if ($("body").hasClass("clr-product")) {
        $(".header__inline--ordertime").hide();
    }

    const format1 = "DD-MM-YYYY";
    var warehouseTZ = "America/New_York";
    var saleMode = false; // set true during sales otherwise false

    // 🔥 Define ALL no-ship holidays here
    var noShipDates = [
        "25-12-2026", // Christmas
        "01-01-2027"  // New Year
    ];

    const selectors = {
        countdownText: ".shippingCountdownText"
    };

    var offsetHour = 10;
    var offsetMinute = 30;

    function isBeforeOffset(hour, minute) {
        return hour < offsetHour || (hour === offsetHour && minute < offsetMinute);
    }

    function isHoliday(dateMoment) {
        return noShipDates.includes(dateMoment.format(format1));
    }

    function getNextValidShipDate(baseMoment) {

        var testDate = moment(baseMoment).clone();

        while (
            testDate.isoWeekday() > 5 ||   // weekend
            isHoliday(testDate)            // holiday
        ) {
            testDate.add(1, "day");
        }

        return testDate;
    }

    function calculateShipDate(nowMoment) {

        var cutoffToday = moment.tz(warehouseTZ)
            .startOf("day")
            .add(offsetHour, "hours")
            .add(offsetMinute, "minutes");

        var effectiveDate = nowMoment.clone();

        // Treat as after cutoff if saleMode OR after cutoff time
        if (saleMode || !nowMoment.isBefore(cutoffToday)) {
            effectiveDate.add(1, "day");
        }

        return getNextValidShipDate(effectiveDate);
    }

    function getDescriptor(shipDateWarehouseTZ) {

        // Visitor's local time
        var localNow = moment();

        // Convert ship date (which is Eastern-based) into visitor local time
        var localShipDate = shipDateWarehouseTZ.clone().local();

        var localToday = localNow.clone().startOf("day");
        var diffDays = localShipDate.startOf("day").diff(localToday, "days");

        if (diffDays === 0) return "today";
        if (diffDays === 1) return "tomorrow";

        return localShipDate.format("dddd");
    }

    if ($(selectors.countdownText).length) {

        var now = moment.tz(warehouseTZ);

        var cutoffToday = moment.tz(warehouseTZ)
            .startOf("day")
            .add(offsetHour, "hours")
            .add(offsetMinute, "minutes");

        var midnightNext = moment.tz(warehouseTZ)
            .startOf("day")
            .add(1, "day");

        var targetTime = now.isBefore(cutoffToday) && !saleMode
            ? cutoffToday
            : midnightNext;

        $(selectors.countdownText).countdown(targetTime.toDate(), function(o) {

            var currentNow = moment.tz(warehouseTZ);

            var shipDate = calculateShipDate(currentNow);
            var daydescriptor = getDescriptor(shipDate);

            if (o.offset.totalSeconds <= 0) {

                var newNow = moment.tz(warehouseTZ);

                var newCutoff = moment.tz(warehouseTZ)
                    .startOf("day")
                    .add(offsetHour, "hours")
                    .add(offsetMinute, "minutes");

                var newTarget = newNow.isBefore(newCutoff) && !saleMode
                    ? newCutoff
                    : moment.tz(warehouseTZ).startOf("day").add(1, "day");

                $(this).countdown(newTarget.toDate());
                return;
            }

            if (o.offset.hours < 1) {
                $(this).html(
                    o.strftime(
                        "Order within <strong>%-M min</strong> <strong>%S sec</strong> and it ships <strong>FREE " +
                        daydescriptor +
                        "</strong>."
                    )
                );
            } else {
                $(this).html(
                    o.strftime(
                        "Order within <strong>%-H hr</strong> <strong>%-M min</strong> and it ships <strong>FREE " +
                        daydescriptor +
                        "</strong>."
                    )
                );
            }

        });
    }

});